import React, { useState } from 'react';

const CalculatorModal = ({ onClose, floating = false }) => {
    const [input, setInput] = useState('');
    const [result, setResult] = useState('');

    const handleInput = (value) => {
        if (result) {
            // If there is a previous result, start a new calculation with it if an operator is pressed,
            // or clear it if a number is pressed.
            if (result !== 'Error' && ['/', '*', '-', '+'].includes(value)) {
                 setInput(result + value);
            } else {
                 setInput(value);
            }
            setResult('');
        } else {
            setInput(input + value);
        }
    };

    const calculateResult = () => {
        try {
            // Input comes only from the numeric/operator keypad.
            if (!input || !/^[\d.\s+*/-]+$/.test(input)) return;
            // eslint-disable-next-line no-new-func
            const calculatedResult = new Function('return ' + input)();
            setResult(Number.isFinite(calculatedResult) ? Number(calculatedResult.toPrecision(12)).toString() : 'Error');
        } catch (error) {
            setResult('Error');
        }
    };

    const clearInput = () => {
        setInput('');
        setResult('');
    };

    const backspace = () => {
        if (result) {
            clearInput();
        } else {
            setInput(input.slice(0, -1));
        }
    };

    const buttons = [
        '7', '8', '9', '/',
        '4', '5', '6', '*',
        '1', '2', '3', '-',
        '0', '.', '=', '+'
    ];

    const handleButtonClick = (btn) => {
        if (btn === '=') {
            calculateResult();
        } else { 
            handleInput(btn);
        }
    };

    return (
        <div className={floating ? 'fixed bottom-4 right-4 z-[110] w-80 max-w-[calc(100vw-2rem)]' : 'fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'}>
            <div role="dialog" aria-label="Calculator" aria-modal={floating ? undefined : true} onKeyDown={event => {if(event.key === 'Escape'){event.stopPropagation();onClose();}}} className="bg-white p-4 rounded-lg shadow-2xl w-full max-w-xs border border-purple-200" style={{maxHeight:'calc(100vh - 2rem)',overflowY:'auto'}}>
                 <div className="flex justify-between items-center mb-2">
                    <h3 className="text-lg font-bold">Calculator</h3>
                    <button type="button" aria-label={floating ? 'Minimise calculator' : 'Close calculator'} onClick={onClose} className="text-2xl font-bold text-gray-500 hover:text-gray-800">{floating ? '−' : '×'}</button>
                 </div>
                <div role="status" aria-label="Calculator result" className="bg-gray-100 p-4 rounded text-right text-2xl font-mono mb-4 h-16 flex items-center justify-end overflow-x-auto">
                    {result || input || '0'}
                </div>
                <div className="grid grid-cols-4 gap-2">
                    <button onClick={clearInput} className="col-span-2 bg-red-500 text-white p-3 rounded hover:bg-red-600 font-bold">C</button>
                    <button onClick={backspace} className="col-span-2 bg-gray-300 p-3 rounded hover:bg-gray-400 font-bold" aria-label="Backspace">{'⌫'}</button>
                    
                    {/* Render remaining buttons */}
                    {buttons.map((btn) => (
                        <button
                            key={btn}
                            onClick={() => handleButtonClick(btn)}
                            className={`p-3 rounded font-bold ${['/', '*', '-', '+', '='].includes(btn) ? 'bg-purple-500 text-white' : 'bg-gray-300'} hover:opacity-80`}
                        >
                            {btn}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CalculatorModal;
